(function() {
    'use strict';
    angular
        .module('prelimApp')
        .factory('PrelimService', PrelimService);

    PrelimService.$inject = ['$resource', 'DateUtils' ,'$q', 'GLOBAL_URL', '$filter', '$window'];
    
    function PrelimService ($resource, DateUtils, $q, GLOBAL_URL, $filter, $window) {
        return $resource(GLOBAL_URL + 'api/ga/prelim/:uri',{uri: '@uri'}, {
            'query': { method: 'GET', isArray: true},
            'get': {
            	method: 'GET',
                transformRequest: function(data, headers){
                    headers = {'Content-Type': 'application/json'};
                    return data;
                }
            },
            'post': {
                method: 'POST'
            },
            'postList':   {method:'POST', isArray: true},
            'download': {
                method: 'POST',
                responseType: 'arraybuffer',
                transformResponse: [function (data,header) {
                	var header = header();
                	downLoad(data,header['file-type'],header['file-export']);
                }],
            },
        });
        
        /**
    	 * DownLoad report
    	 */
    	function downLoad(response, type, fileName) {
    			var file = new Blob([response], {type: type});
    		  if (navigator.appVersion.toString().indexOf('.NET') > 0) { // for IE browser
    	           $window.navigator.msSaveBlob(file, fileName);
    	       } else { // for other browsers
    	    	   var fileURL = $window.URL.createObjectURL(file);
    	    	   // Test tren chorme va firefox
  	    		 	var theAnchor = $('<a />')  
				        .attr('href', fileURL)  
				        .attr('download',fileName)
				        .attr('target','_blank')
				         .appendTo('body');
	 			    theAnchor[0].click();   
	 			    theAnchor.remove();  
    	       }
    		
    	};
    }
})();
